import { api } from "@api/api";
import { Sector } from "@modules/bookSectors/types";
import { SectorFormValues } from "@modules/bookSectors/validations";

export async function editSectorService(id: string, data: SectorFormValues): Promise<Sector> {
  const { data: sector } = await api.patch<Sector>(`v1/book_sector_admin/${id}/`, data);

  return sector;
}
